module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-8-6f2c7e85fa577e22b651023735b4d6a6.jpg";